/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import {ReactComponent as Logo} from "./Logo.svg";

export function BrandLogo() {
  return <Logo />;
}
